import { Component, Input, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { SupplierDocument } from 'app/profile/models/supplier.model';
import { OnboardingDocumentsService } from 'app/profile/services/onboarding-document.service';

@Component({
  selector: 'app-rejection-details',
  templateUrl: './rejection-details.component.html',
  styleUrls: ['./rejection-details.component.scss']
})
export class RejectionDetailsComponent implements OnInit {
  @Input('rejectionDetails') rejectionDetails: any;
  @Input('supplierCode') supplierCode: string;

  constructor(private onboardingDocumentsService: OnboardingDocumentsService,) {
  }

  ngOnInit(): void {
  }

  DownloadFile(document: SupplierDocument) {
    if (document.DocumentID) {
      this.onboardingDocumentsService.downloadDocument(document.DocumentID, this.supplierCode, document.DocumentVersion).subscribe(resultBlob => {
        FileSaver.saveAs(resultBlob, document.FileName || document.DocumentID);
      });
    }
  }

}
